import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider, createTheme} from "@mui/material/styles";
import {AuthProvider} from "react-oidc-context";
import {Navigate, Route, BrowserRouter as Router, Routes} from "react-router-dom";
import AIAnalysisForm from "./components/AIAnalysisForm";
import Login from "./components/Auth/Login";
import OidcCallback from "./components/Auth/OidcCallback";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import Layout from "./components/Layout";
import {oidcConfig} from "./config/oidcConfig";

// Crear tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2"
    },
    secondary: {
      main: "#dc004e"
    },
    background: {
      default: "#f5f5f5"
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  shape: {
    borderRadius: 8
  }
});

function App() {
  return (
    <AuthProvider {...oidcConfig}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            {/* Ruta pública de login */}
            <Route path="/login" element={<Login />} />

            {/* Callback de OpenID Connect */}
            <Route path="/callback" element={<OidcCallback />} />

            {/* Ruta principal protegida */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AIAnalysisForm />
                  </Layout>
                </ProtectedRoute>
              }
            />

            {/* Redirigir cualquier otra ruta al login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
